import { RecipeCard } from "@components/RecipeCard/RecipeCard";
import { useQSSKey } from "@contexts/QueryStringStorageContext";
import { useQueryStringStorage } from "@hooks/useQueryStringStorage/useQueryStringStorage";
import React from "react";

import { RecipeHit as RecipeHitType } from "../types/RecipeHit";

const RecipeHit = (props: {
    hit: RecipeHitType;
    placement: string;
    onClick?: (hit: RecipeHitType) => void;
    refinements?: { type: string; refine: (arg: string) => string }[];
    hoverOnTags?: boolean;
}): JSX.Element => {
    const { hit, placement, onClick, refinements, hoverOnTags = false } = props;

    const qss = useQueryStringStorage();
    const qssKey = useQSSKey();

    const onTagClick = (e: React.MouseEvent, tag: { label: string; type: string }): void => {
        const currentRefinement = refinements && refinements?.find((r) => r.type === tag?.type);
        if (currentRefinement) {
            currentRefinement && currentRefinement?.refine(tag?.label);
            qss.handleQueryParam(qssKey, tag?.type, tag?.label);
            e.preventDefault();
            e.stopPropagation();
        }
    };

    return (
        <span onClick={() => onClick && onClick(hit)} role="presentation">
            <RecipeCard
                position={hit?.__position}
                hoverOnTags={hoverOnTags}
                placement={placement}
                title={hit?.title}
                url={hit?.uri}
                imageData={hit?.imageData}
                specialty={hit?.specialty}
                course={hit?.course}
                dietary_wishes={hit?.dietary_wishes}
                difficulty={hit?.difficulty}
                onTagClick={onTagClick}
            />
        </span>
    );
};

export default RecipeHit;
